import type { JSX } from "react";

import { Group, Text } from "@mantine/core";

import { ListeningAnimation } from "@/common-ui";

export function TranscriptFooter(): JSX.Element | undefined {
    return (
        <Group pb="xxl" mah="1rem" gap="xs">
            <ListeningAnimation style={{ width: "1rem" }} />
            <Text c="dark.3" size="xs">
                Transcribing...
            </Text>
        </Group>
    );
}
